import { useScatterplotContext } from 'features/timeSeries'
import { ChartTooltip } from 'features/timeSeries/components/ChartTooltip'
import React from 'react'
import styled from 'styled-components'

const Notice = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(15, 15, 15, 0.95);
  font-family: 'Manrope', sans-serif;
  font-size: 11px;
  color: #ccc;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
`

const ShowAllButton = styled.button`
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 3px;
  padding: 3px 7px;
  color: #fff;
  font-family: inherit;
  font-size: 11px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.16);
  }
`

/**
 * Says out loud that the chart is showing fewer pens than it was asked for.
 *
 * The cap is a real tradeoff — a chart plotting every sensor at a site is both
 * unreadable and pathologically expensive — but hiding the cap would recreate
 * the failure this page is built around: a chart quietly showing less than
 * reality with no way to tell. So the count is exact and the override is one
 * click, not a support ticket.
 */
export const PenCapNotice: React.FC = () => {
  const { penCap } = useScatterplotContext()

  if (!penCap.isCapped) return null

  return (
    <Notice role='status' data-testid='pen-cap-notice'>
      <span>
        Showing {penCap.shown.toLocaleString()} of{' '}
        {penCap.requested.toLocaleString()} pens
      </span>
      <ChartTooltip
        label={`Load all ${penCap.requested.toLocaleString()} pens. This chart may take minutes to load and will be hard to read.`}
        side='top'>
        <ShowAllButton type='button' onClick={penCap.showAll}>
          Show all
        </ShowAllButton>
      </ChartTooltip>
    </Notice>
  )
}
